import React from "react";
import {
  getActivityEventDisplay,
  getActivityActorDisplay,
  formatActivityTimestamp,
  formatActivityMetaDetail,
} from "./vendorActivityUtils";

/**
 * @param {object} props
 * @param {Array<{ id: number, eventType: string, actorType: string, createdAt: string, metaJson?: object }>} props.logs
 */
export default function VendorActivityList({ logs }) {
  if (!logs || logs.length === 0) {
    return <p className="small text-muted mb-0">No events yet.</p>;
  }

  return (
    <div
      className="list-group list-group-flush small border rounded overflow-y-auto"
      style={{ maxHeight: "min(50vh, 420px)" }}
      role="region"
      aria-label="Activity timeline"
    >
      {logs.map((log) => {
        const ev = getActivityEventDisplay(log.eventType || log.event_type);
        const actor = getActivityActorDisplay(log.actorType || log.actor_type);
        const at = log.createdAt || log.created_at;
        const meta = log.metaJson || log.meta_json;
        const detailLines = formatActivityMetaDetail(meta, ev.key);
        return (
          <div
            key={log.id}
            className="list-group-item px-3 py-2 border-0 border-bottom bg-white"
          >
            <div className="d-flex gap-2 align-items-start">
              <i className={`bi ${ev.icon} fs-5 flex-shrink-0 ${ev.iconClass}`} aria-hidden="true" />
              <div className="flex-grow-1 min-w-0">
                <div className="d-flex flex-wrap align-items-center gap-2 mb-0">
                  <span className="fw-semibold text-dark">{ev.label}</span>
                  <span className={`badge ${actor.badgeClass}`}>{actor.label}</span>
                </div>
                {ev.description ? (
                  <div className="text-muted mt-1" style={{ fontSize: "0.8rem", lineHeight: 1.35 }}>
                    {ev.description}
                  </div>
                ) : null}
                {detailLines.length > 0 ? (
                  <ul className="mb-0 mt-2 ps-3 text-dark" style={{ fontSize: "0.8rem", lineHeight: 1.45 }}>
                    {detailLines.map((line, i) => (
                      <li key={i}>{line}</li>
                    ))}
                  </ul>
                ) : null}
                <time
                  className="text-muted d-block mt-1"
                  style={{ fontSize: "0.75rem" }}
                  dateTime={at}
                >
                  {formatActivityTimestamp(at)}
                </time>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
